var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadioButtonOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000052093236168224833080000003534641764786080668_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF00"
    },
    d: "M25,1.7c12.8,0,23.3,10.5,23.3,23.3S37.8,48.3,25,48.3S1.7,37.8,1.7,25S12.2,1.7,25,1.7 M25,0 C11.2,0,0,11.2,0,25s11.2,25,25,25s25-11.2,25-25S38.8,0,25,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF00"
    },
    d: "M25,10.5c8,0,14.5,6.5,14.5,14.5S33,39.5,25,39.5S10.5,33,10.5,25S17,10.5,25,10.5 M25,8.8 C16,8.8,8.8,16,8.8,25S16,41.2,25,41.2S41.2,34,41.2,25S34,8.8,25,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF00"
    },
    d: "M25,31.4c-3.5,0-6.4-2.8-6.4-6.4c0-3.5,2.8-6.4,6.4-6.4s6.4,2.8,6.4,6.4 C31.4,28.5,28.5,31.4,25,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF00"
    },
    d: "M25,19.5c3,0,5.5,2.5,5.5,5.5S28,30.5,25,30.5S19.5,28,19.5,25S22,19.5,25,19.5 M25,17.8 c-4,0-7.2,3.2-7.2,7.2s3.2,7.2,7.2,7.2s7.2-3.2,7.2-7.2S29,17.8,25,17.8z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioButtonOn);
export default __webpack_public_path__ + "static/media/radio-button-on.5e7c3639a5ea91f695341ff776aa549c.svg";
export { ForwardRef as ReactComponent };